// Creates new Timer and assigns ID and type
export const createTimer = (data) => {
    //data = {id, type}
    return { type: "CREATE_TIMER", payload: data}
}

// Set timer running state
export const setTimerRunning = (data) => {
    //data = {id, open}
    return { type: "SET_TIMER_RUNNING", payload: data}
}

// Set whether the timer popup is displayed or not
export const setTimerShowPopup = (data) => {
    //data = {id, open}
    return { type: "SET_TIMER_POPUP", payload: data}
}

// Set the timer time
export const setTimerTime = (data) => {
    //data = {id, open}
    return { type: "SET_TIMER_TIME", payload: data}
}